var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00781 12C7.00781 11.5858 7.34359 11.25 7.75781 11.25H11.2504V7.75732C11.2504 7.34311 11.5862 7.00732 12.0004 7.00732C12.4146 7.00732 12.7504 7.34311 12.7504 7.75732V11.25H16.2431C16.6573 11.25 16.9931 11.5858 16.9931 12C16.9931 12.4142 16.6573 12.75 16.2431 12.75H12.7504V16.2426C12.7504 16.6569 12.4146 16.9926 12.0004 16.9926C11.5862 16.9926 11.2504 16.6569 11.2504 16.2426V12.75H7.75781C7.34359 12.75 7.00781 12.4142 7.00781 12Z",
    fill: "#F77E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31649 3.76882C10.4041 3.42374 13.5955 3.42374 16.683 3.76882C18.5094 3.97294 19.9843 5.41159 20.1992 7.24855C20.5684 10.4055 20.5684 13.5947 20.1992 16.7516C19.9843 18.5886 18.5094 20.0272 16.683 20.2314C13.5955 20.5764 10.4041 20.5764 7.31649 20.2314C5.49011 20.0272 4.01521 18.5886 3.80036 16.7516C3.43113 13.5947 3.43113 10.4055 3.80036 7.24855C4.01521 5.41159 5.49011 3.97294 7.31649 3.76882ZM16.5164 5.25954C13.5396 4.92683 10.46 4.92683 7.4831 5.25954C6.33867 5.38744 5.42262 6.29069 5.29021 7.4228C4.93452 10.464 4.93452 13.5362 5.29021 16.5774C5.42262 17.7095 6.33867 18.6127 7.4831 18.7406C10.46 19.0733 13.5396 19.0733 16.5164 18.7406C17.6609 18.6127 18.5769 17.7095 18.7093 16.5774C19.065 13.5362 19.065 10.464 18.7093 7.4228C18.5769 6.29069 17.6609 5.38744 16.5164 5.25954Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconColored);
export default __webpack_public_path__ + "static/media/addIconColored.70ce48df050f8a5641cbe6ebd2567bbd.svg";
export { ForwardRef as ReactComponent };